import { cn } from '@/lib/utils';

// Vertical group inside the panel body. Uppercase tracking-wide label
// is the ONLY uppercase usage allowed in the inspector — section
// labels only, never field labels or body copy.

interface InspectorSectionProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
}

export function InspectorSection({ label, children, className }: InspectorSectionProps) {
  return (
    <section
      className={cn(
        'px-4 py-4 border-b border-border-subtle last:border-b-0',
        className,
      )}
    >
      {label ? (
        <h3 className="mb-3 eyebrow">
          {label}
        </h3>
      ) : null}
      {children}
    </section>
  );
}
